
// src/components/ValueFlash.jsx
import React, { useEffect, useRef, useState } from "react";

export function ValueFlash({ value, fmt }) {
    const prev = useRef();
    const [flash, setFlash] = useState(false);

    useEffect(() => {
        if (prev.current !== undefined && prev.current !== value) {
            setFlash(true);
            const id = setTimeout(() => setFlash(false), 600);
            return () => clearTimeout(id);
        }
        prev.current = value;
    }, [value]);

    const text = value == null ? "—" : (fmt ? fmt(value) : String(value));
    return <span className={flash ? "value-flash" : undefined}>{text}</span>;
}
